import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import html2pdf from "html2pdf.js";
import Modal from "react-modal";
import Pagination from "../../../../components/Pagination";
import { useAuth } from "../../../../store/auth";
import { useNavigate } from "react-router-dom";
import { logDOM } from "@testing-library/react";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";


const FarmerGoodsIssueReportFMN = () => {
  const { orgData } = useAuth();
  const navigate = useNavigate();
 const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      // border: "5px solid #96dc00",
    },
  };
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const [logoBase64, setLogoBase64] = useState("");

  const [logoSrc, setLogoSrc] = useState("");

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const { sendRequest: getPdfData } = useHttp();

  const viewPdf = (data) => {
    setPdfView(true);

    const Id = data.goodIssueId || 0;
    if (Id) {
      getPdfData(
        {
          url: `/api/goodsIssueReport/?orgId=${localStorage.getItem(
            "orgId"
          )}&goodIssueId=${Id}`,
        },
        (data) => {
          setPdfData(data);
          console.log(data);
        }
      );
    }
  };

  const generatePDF = (salesOrderCode) => {
    const input = pdfContainerRef.current;

    const pdfName = salesOrderCode || "";

    html2pdf(input, {
      margin: 10,
      filename: `${pdfName}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: "avoid-all" },
    });
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 90);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const loadCountData = (id) => {
    fillprocurementData(id);
  };

  const fillprocurementData = (employeeId, regionId) => {
    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (stateName && typeof stateName === "string" && stateName.trim().length > 0) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    urlfilter =
      urlfilter +
      `&fromDate=${moment(frmRef.current.Fdate.value).format("DD/MM/YYYY")}`;
    urlfilter =
      urlfilter +
      `&toDate=${moment(frmRef.current.Tdate.value).format("DD/MM/YYYY")}`;

    var url = `/api/goodsIssueReportfmn/?orgId=${localStorage.getItem(
      "orgId"
    )}&&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        console.log("data", data);
        var goodsIssueData = data;

        setData(goodsIssueData);
        //   var newList = [];
        //   var i=0;
        //   if(goodsIssueData.length>0)
        //   {

        //   do {
        //     var farmeritem = goodsIssueData[i];

        //     var strgoodsIssue = JSON.stringify(farmeritem.goodsIssue);

        //     var goodsIssue = (JSON.parse(strgoodsIssue))

        //     ////console.log("farmeritem", farmeritem);
        //     ////console.log("strgoodsIssue", farmeritem.goodsIssue);

        //      var j = 0;
        //     if(goodsIssue.length>0)
        //     {
        //   do {

        //      var goodsIssueitem=goodsIssue[j];
        //      var strproductDetails=JSON.stringify(goodsIssueitem.productDetails);
        //      var productDetails=JSON.parse(JSON.parse(strproductDetails));
        //      ////console.log("goodsIssueitem", goodsIssueitem);

        //        newList = newList.concat({
        //       linesrno: j + 1,

        //       executiveName: farmeritem.executiveName,

        //       regionName: farmeritem.regionName,
        //       farmerCode: farmeritem.farmerCode,
        //       farmerName: farmeritem.farmerName,

        //       goodsIssueDate  : goodsIssueitem. goodsIssueDate,
        //       totalAmount  : goodsIssueitem. totalAmount,
        //       discountAmount  : goodsIssueitem. discountAmount,
        //       discount : goodsIssueitem. discount,

        //     });
        //     j++;
        //   } while (goodsIssue.length > j);

        // }
        //     i++;
        //   } while (goodsIssueData.length > i);
        // }
      }
    );
  };

  useEffect(() => {
    fillprocurementData(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRegionData(data);
      }
    );
  }, [getRegion]);

  const fieldsToExport = [
    "farmerName",
    "farmerCode",
    "farmerMobile",
    "executiveName",
    "warehouseName",

    "goodsIssueDate",
    "villageName",
    "state",
    "seasonName",
    "discount",
    "discountAmount",
    "totalAmount",
    "logistics",
    "ccreatedDate",
  ];

  const customHeaders = [
    "Farmer Name",
    "Farmer Code",
    "Farmer Mobile",
    "Executive Name",
    "Warehouse",

    "Goods Issue Date",
    "Village",
    "State",
    "Season Name",
    "Discount",
    "Discount Amount",
    "Total Amount",
    "Logistics",
    "Created Date",
  ];

  const handleExportExcel = () => {
    const filename = "FarmerGoodsIssuedReport.xlsx";
    const processedData = data.map((item) => ({
      ...item,
      createdDate: item.createdDate ? new Date(item.createdDate).toLocaleDateString("en-GB") : "",
      goodsIssueDate: item.goodsIssueDate ? new Date(item.goodsIssueDate).toLocaleDateString("en-GB") : "",
    }));

    convertToExcel(processedData, fieldsToExport, filename, customHeaders);
  };

  useEffect(() => {
    const loadLogo = () => {
      const img = new Image();
      img.src = "/" + localStorage.getItem("organizationName") + ".jpg";
      img.crossOrigin = "anonymous"; // required for canvas/Base64

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        setLogoSrc(canvas.toDataURL("image/png")); // Base64 for PDF
      };

      img.onerror = () => {
        if (orgData?.organizationIcon) {
          setLogoSrc("dist/img/" + localStorage.getItem("organizationName") + ".jpg");
        } else {
          setLogoSrc("");
        }
      };
    };

    loadLogo();
  }, [orgData]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Farmer Goods Issue Detail Reports
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <hr />
            <div className="row"></div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>State</label>
                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        console.log("sName", sName);
                      }
                      setStateName(sName);
                      EmployeeDetail(sName);
                      setData([]);
                      setEmployeeId(0);
                    }}
                  >
                    <option value="">Select</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          user-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option>--Select--</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["Fdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["Tdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData(employeeId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div
                  className="card-body"
                  style={{
                    padding: "0.2rem",
                    maxHeight: "500px", 
                    overflowY: "auto",
                    overflowX: "auto", 
                  }}
                >
                  <table
                    className="table table-bordered table-sm text-center"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      minWidth: "1200px", 
                    }}
                  >
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        backgroundColor: "#f8f9fa",
                        boxShadow: "0px 2px 2px rgba(0,0,0,0.1)", 
                      }}
                    >
                      <tr>
                        <th>Farmer Name</th>
                        <th>Farmer Code</th>
                        <th>Farmer Mobile</th>
                        <th>Executive Name</th>
                        <th>Warehouse</th>
                        <th>Goods Issue Date</th>
                        <th>Village</th>
                        <th>State</th>
                        <th>Season Name</th>
                        <th>Discount</th>
                        <th>Discount Amount</th>
                        <th>Logistics</th>
                        <th>Total Amount</th>
                        <th>View</th>
                        <th>Created Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentItems?.map((itm, i) => (
                        <tr key={i} className="tablerowview">
                          <td>{itm.farmerName}</td>
                          <td>{itm.farmerCode}</td>
                          <td>{itm.farmerMobile}</td>
                          <td>{itm.executiveName}</td>
                          <td>{itm.warehouseName}</td>
                          <td>{new Date(itm.goodsIssueDate).toLocaleDateString()}</td>
                          <td>{itm.villageName}</td>
                          <td>{itm.state}</td>
                          <td>{itm.seasonName}</td>
                          <td>{itm.discount}</td>
                          <td>{parseFloat(itm.discountAmount || 0).toFixed(2)}</td>
                          <td>{parseFloat(itm.logistics || 0).toFixed(2)}</td>
                          <td>{parseFloat(itm.totalAmount || 0).toFixed(2)}</td>
                          <td>
                            <button className="btn" onClick={() => viewPdf(itm)}>
                              <i className="fas fa-eye"></i>
                            </button>
                          </td>
                          <td>{new Date(itm.createdDate).toLocaleDateString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="card-footer clearfix">
                  <Pagination
                    totalItems={data.length}
                    itemsPerPage={itemsPerPage}
                    onPageChange={paginate}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>

          </div>
        </section>
      </div>
      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container ">
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setPdfView(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>

            <div className="pdf-container mx-3 my-4" ref={pdfContainerRef}>
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      {/* Main content */}
                      <div className="invoice p-3 mb-3">
                        {/* title row */}
                        <div className="row">
                          <div className="col-12">
                            <h4>
                              {logoSrc && (
                                <img
                                  src={logoSrc}
                                  width="50"
                                  height="50"
                                  alt=""
                                  style={{ marginRight: "10px" }}
                                />
                              )}Farmer Good Issue Details
                            </h4>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* info row */}
                        <div className="row invoice-info">
                          <div className="col-sm-4 invoice-col">
                            From
                            <address>
                              <strong>{orgData && orgData.orgName}</strong>
                              <br />
                              {orgData && orgData.city}{" "}
                              {orgData && orgData.state}
                              <br />
                              {orgData && orgData.country}{" "}
                              {orgData && orgData.zipCode}
                              <br />
                              Phone: {orgData && orgData.phoneNumber}
                              <br />
                              Email: {orgData && orgData.orgEmail}
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            To
                            <address>
                              <strong>{pdfData && pdfData.farmerName}</strong>
                              <br />
                              Farmer Code: {pdfData && pdfData.farmerCode}
                              <br />
                              Phone: {pdfData && pdfData.workContactNumber}
                              <br />
                              Email: {pdfData && pdfData.customerEmailId}
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            <br />
                            <b>Date:</b> {pdfData && pdfData.goodsIssueDate}
                            <br />
                            <br />
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        {/* Table row */}
                        <div className="row">
                          <div className="col-12 table-responsive">
                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th>Sr.No</th>

                                  <th>Product Name</th>

                                  <th>Rate</th>
                                  <th>Quantity</th>
                                  <th>Unit</th>

                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pdfData.productData &&
                                  pdfData.productData.map((itm, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>{i + 1}</td>

                                        <td>{itm.productName}</td>

                                        <td>{itm.salesRate}</td>
                                        <td>{itm.useQty}</td>
                                        <td>{itm.unit}</td>

                                        <td>{itm.useAmt}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        <div className="row">
                          <div className="col-6">
                            <p className="text-muted well well-sm shadow-none">
                              Remark/Note:
                            </p>
                            <p> {pdfData && pdfData.remark}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Name of Authorized Signatory:
                            </p>
                            <hr />

                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              This is Computer Generated Document
                            </p>
                          </div>

                          <div className="col-6">
                            <div className="table-responsive">
                              <table className="table">
                                <tbody className="text-right">
                                  <tr>
                                    <th>
                                      Discount ({pdfData && pdfData.discount}%)
                                    </th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.discountAmount}
                                    </td>
                                  </tr>

                                  <tr>
                                    <th>Logistics</th>
                                    <td> {pdfData && pdfData.logistics}</td>
                                  </tr>

                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Amount:
                                    </th>
                                    <td> {pdfData && pdfData.totalAmount}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row no-print">
            <div className="col-12">
              <button
                type="button"
                className="btn btn-primary float-right generate-pdf-button"
                style={{ marginRight: 5 }}
                onClick={() => generatePDF(pdfData && pdfData.salesOrderCode)}
              >
                <i className="fas fa-download" /> Generate PDF
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default FarmerGoodsIssueReportFMN;
